// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1weUk","list":"PatternAutocomplete_list__3hSD3"};